import { render } from "./RelatorioMediaEstrela.vue?vue&type=template&id=09325902&scoped=true"
import script from "./RelatorioMediaEstrela.vue?vue&type=script&lang=js"
export * from "./RelatorioMediaEstrela.vue?vue&type=script&lang=js"

import "./RelatorioMediaEstrela.vue?vue&type=style&index=0&id=09325902&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09325902"]])

export default __exports__